import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { getTableHandHistory } from '@/services/hand-history/hand-history.service';
import { HandHistory } from '@/services/hand-history/hand-history.types';

const useGetTableHandHistory = (tableId: string): UseQueryResult<HandHistory[]> => {
  return useQuery<HandHistory[]>({
    queryKey: ['tableHandHistory', tableId],
    queryFn: () => getTableHandHistory(tableId),
    refetchOnWindowFocus: true,
  });
};

export default useGetTableHandHistory;
